import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { UiIconComponent } from '../ui-icon/ui-icon.component';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-arrow-button',
  templateUrl: './arrow-button.component.html',
  styleUrl: './arrow-button.component.scss'
})
export class ArrowButtonComponent {
  @Input() direction?: 'left' | 'right' | 'top';
  @Input() size?: 'sm';
  @Input() ariaLabel?: string;
  @Input() classNames?: string;
  @Output() clickEmitter = new EventEmitter<void>();
  @ViewChild('buttonElement', { static: true }) buttonElement!: ElementRef<HTMLButtonElement>;
}
